// @flow
import React from 'react'
import { NavLink } from 'react-router-dom'

import styles from './styles.css'

type HeaderNavItemProps = {
  label: string,
  to?: string,
  onClick?: () => void,
  id?: string,
}

const HeaderNavItem = (props: HeaderNavItemProps) => {
  const { label, to, onClick, id } = props

  return (
    <NavLink
      to={to}
      id={id}
      className={({ isActive, isPending }) => {
        return isActive
          ? `${styles.headerNavItem} ${styles.headerNavItemActive}`
          : styles.headerNavItem
      }}
      onClick={onClick}
    >
      {label}
    </NavLink>
  )
}

export default HeaderNavItem
